import { createSlice } from "@reduxjs/toolkit";

import { checkArbitrumProof } from "./actions";
import { getProof } from "../solana-proof/actions";

import { ArbitrumProofState } from "./types";
import { LOCAL_STORAGE_KEYS } from "configs";

export const applyArbitrumToken = (key: string, token: ArbitrumProofState["arbitrumProofToken"]) => {
  if (token) {
    localStorage.setItem(key, token);
  } else {
    localStorage.removeItem(key);
  }

  return token;
};

const initialState: ArbitrumProofState = {
  pending: false,
  error: null,
  arbitrumProofToken: null,
};

const arbitrumSlice = createSlice({
  name: "arbitrumProof",
  initialState: {
    ...initialState,
    arbitrumProofToken: localStorage.getItem(LOCAL_STORAGE_KEYS.arbitrumToken),
  },
  reducers: {
    resetArbitrumProofState: () => {
      applyArbitrumToken(LOCAL_STORAGE_KEYS.arbitrumToken, null);
      localStorage.removeItem(LOCAL_STORAGE_KEYS.arbitrumWallet);
      return initialState;
    },
  },
  extraReducers: builder => {
    builder
      // get proof payload
      .addCase(getProof.pending, state => {
        state.pending = true;
      })
      .addCase(getProof.fulfilled, (state, action) => {
        state.arbitrumPayload = action.payload;
        state.error = null;
        state.pending = false;
      })
      .addCase(getProof.rejected, (state, action) => {
        if (action.payload) {
          state.error = action.payload;
          state.pending = false;
        }
      })
      // check arbitrum proof
      .addCase(checkArbitrumProof.pending, state => {
        state.pending = true;
      })
      .addCase(checkArbitrumProof.fulfilled, (state, action) => {
        const { token } = action.payload;
        state.error = null;
        state.arbitrumProofToken = applyArbitrumToken(LOCAL_STORAGE_KEYS.arbitrumToken, token);
        state.pending = false;
      })
      .addCase(checkArbitrumProof.rejected, (state, action) => {
        if (action.payload) {
          state.error = action.payload;
          state.arbitrumProofToken = applyArbitrumToken(LOCAL_STORAGE_KEYS.arbitrumToken, null);
          state.pending = false;
        }
      });
  },
});

export const { resetArbitrumProofState } = arbitrumSlice.actions;

export default arbitrumSlice;
